<template>
  <div class="prospectos-wrap">
    <v-card class="prospectos-card elevation-3">
      <v-toolbar flat class="prospectos-hero">
        <div class="d-flex align-center" style="gap: 12px;">
          <v-avatar color="white" size="44" class="elevation-2">
            <v-icon color="deep-orange darken-4">mdi-account-group</v-icon>
          </v-avatar>
          <div>
            <div class="text-h6 white--text">Embudo comercial</div>
            <div class="text-body-2 white--text">
              Gestiona contactos, prospectos y pre-inscritos en un solo lugar
            </div>
          </div>
        </div>
        <v-spacer></v-spacer>
        <v-chip color="yellow darken-2" class="deep-orange--text text--darken-4" small>
          Activo
        </v-chip>
      </v-toolbar>

      <v-tabs v-model="tab" align-with-title class="prospectos-tabs" grow>
        <v-tabs-slider color="yellow"></v-tabs-slider>

        <v-tab>
          <v-icon left>mdi-account</v-icon>
          Contactos
          <v-chip x-small class="ml-2" color="yellow darken-2">1</v-chip>
        </v-tab>
        <v-tab>
          <v-icon left>mdi-briefcase-account</v-icon>
          Prospectos
          <v-chip x-small class="ml-2" color="yellow darken-2">2</v-chip>
        </v-tab>
        <v-tab>
          <v-icon left>mdi-file-document-edit</v-icon>
          Pre-inscritos
          <v-chip x-small class="ml-2" color="yellow darken-2">3</v-chip>
        </v-tab>
        <!-- <v-tab>
          <v-icon left>mdi-file-document-edit</v-icon>
          Mis Inscripciones
          <v-chip x-small class="ml-2" color="yellow darken-2">4</v-chip>
        </v-tab> -->
      </v-tabs>

      <v-divider></v-divider>

      <v-card-text class="pt-0">
        <v-tabs-items v-model="tab">
          <v-tab-item>
            <indexContactos ref="refindexContactos" />
          </v-tab-item>

          <v-tab-item>
            <indexProspectos ref="refindexProspectos" />
          </v-tab-item>
          <v-tab-item>
            <MisInscripciones ref="refMisInscripciones" />
          </v-tab-item>
          <!-- <index_preregistros ref="refindex_preregistros" /> -->
          <!-- <v-tab-item>
            <index_preinscritos ref="refindex_preinscritos" />
          </v-tab-item> -->
        </v-tabs-items>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
  import indexContactos from './index-contactos.vue';
  import indexProspectos from './index-prospectos.vue';
  // import index_preregistros from './index_preregistros.vue';
  // import index_preinscritos from './index_preinscritos.vue';
  import MisInscripciones from '@/views/MisInscripciones.vue'
  export default {
    components: {
      indexContactos,
      indexProspectos,
      // index_preinscritos,
      // index_preregistros,
      MisInscripciones,
    },
    data() {
      return {
        tab: null,
      };
    },
    watch:{
      'tab': function (){
        if(this.tab){
          if(this.$refs.refindexContactos) this.$refs.refindexContactos.listar()
          if(this.$refs.refindexProspectos) this.$refs.refindexProspectos.listar()
          if(this.$refs.refindex_preregistros) this.$refs.refindex_preregistros.listar()
        }
      }
    }
  };
</script>

<style scoped>
.prospectos-wrap {
  padding: 0px 16px 0px 16px;
}
.prospectos-card {
  border-radius: 16px;
  overflow: hidden;
}
.prospectos-hero {
  min-height: 88px;
  background: linear-gradient(120deg, #ff6a00 0%, #ff3d00 45%, #ffb300 100%);
}
.prospectos-tabs {
  background: #fff3e0;
}
</style>
